import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
/* import './registerServiceWorker' */
import M from 'materialize-css'
import authService from '@/services/authService'
import Vuelidate from 'vuelidate'
import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)
Vue.use(Vuelidate)
Vue.config.productionTip = false

let mBoxed = () => {
	Vue.directive('expandable', {
		bind: function (el) { 
			setTimeout(() => {
				const mBoxedOptions = {
					overlayActive:false
				}
				M.Materialbox.init(el, mBoxedOptions);
			}, 300);
			}
		} 
		)
}

let tTipped = () => {
	Vue.directive('tipped', {
		bind: function (el) { 
			setTimeout(() => {
				const options = { 	}
				M.Tooltip.init(el,options);
        }, 300);
      },
      unbind: function (el) {
				setTimeout(() => {
					let instance = M.Tooltip.getInstance(el)
					instance.destroy()
				}, 300);
   
      }
		} 
		)
}

let VueTruncate = () => {
	Vue.filter('truncate', function (text, length, clamp) {
		text = text || '';
		clamp = clamp || '...';
		length = length || 30;

		let to = document.createElement('DIV')
		to.innerHTML = text
		let arr = to.children.length > 0 ? to.children[0].children : []
		if (arr.length > 0 && to.children[0].nodeName == 'UL' ) {
		
			for (let index = 0; index < arr.length; index++) {
				arr[index].insertAdjacentHTML('afterend', ', ')
				if ((index + 1 == arr.length)) text = to.children[0].textContent
			}

		} else {
			if(to.children.length > 0) {
		
				text = to.children[0].textContent
			}
			else {
				text = to.textContent
			}
		
		}

		// console.log(`${text}`)
		if (text.length <= length) return text;
		let tcText = text.slice(0, length - clamp.length);
		let last = tcText.length - 1;

		while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;
		// Fix for case when text dont have any `space`
		last = last || length - clamp.length;
		tcText = tcText.slice(0, last);
		return tcText + clamp;
	});
}
router.beforeEach((to, from, next) => {
  let auth = authService.getCookie('wcmCookie') !== ''
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !auth) {
   next('/login'); 
  } else if (requiresAuth) {
   next();
  } else {
   next();
  }
	});
	
Vue.config.productionTip = false
Vue.use(tTipped)
Vue.use(mBoxed)
Vue.use(VueTruncate)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
